import { ConfirmationDialog } from '@/components/shared/ConfirmationDialog/ConfirmationDialog';
import { Divider, SxProps, Theme } from '@mui/material';

type DeleteConfirmationModalProps = {
  isOpen: boolean;
  title: string;
  itemName?: string;
  description?: string;
  onConfirm: () => void;
  onCancel?: () => void;
  handleClose: () => void;
  loading?: {
    state: boolean;
    text: string;
  };
  handleCloseModals?: () => void;
  sxStyle?: SxProps<Theme>;
};

export const DeleteConfirmationModal = ({
  isOpen,
  title,
  itemName = 'this item',
  description = `Are you sure you want to delete ${itemName}? This action will permanently remove the ${itemName}`,
  onConfirm,
  onCancel,
  handleClose,
  loading,
  handleCloseModals,
  sxStyle,
}: DeleteConfirmationModalProps) => {
  return (
    <ConfirmationDialog
      title={title}
      description={description}
      confirmButtonText="Delete"
      cancelButtonText="Cancel"
      cancelButtonVariant="outlined"
      onConfirm={onConfirm}
      onCancel={onCancel}
      handleClose={handleClose}
      isOpen={isOpen}
      loading={loading}
      handleCloseModals={handleCloseModals}
      sxStyle={sxStyle}
      children={<Divider sx={{ my: 0, mt: 1 }} />}
    />
  );
};
